import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  pure: true
})
export class FileSizePipe implements PipeTransform {

  transform(length: number): string {
    if (length < 1024) return length + ' bytes';
    if (length < 1024 * 1024) return (length / 1024).toFixed(2) + ' KB';
    if (length < 1024 * 1024 * 1024) return (length / 1024 / 1024).toFixed(2) + ' MB';
    return (length / 1024 / 1024 / 1024).toFixed(2) + ' GB';
  }

}
